/* eslint-disable no-console */

import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app.jsx";
import registerServiceWorker from "./register.service.worker.js";
import { PortalApp } from "./portal.app.jsx";
import { AppBuilder } from "./app.builder.jsx";
import { CustomFormFieldShowcase } from "./custom_form_field_showcase/index.jsx";

import "./reset.css";

function hideConsoleLog() {
  const consoleLog = console.log;
  function fakeLog() {
    try {
      if (window.enableLog || localStorage.getItem("enableLog")) {
        consoleLog(...arguments);
      }
    } catch (e) {
      // throw e;
    }
  }
  console.log = fakeLog;
  console.info = fakeLog;
  console.warn = fakeLog;
  console.error = fakeLog;
}

hideConsoleLog();

const root = createRoot(document.getElementById("app"));

const RootApp = () => {
  let accountDetails = window.accountDetails || {};
  let isPortal = accountDetails.IsPortal;
  const isAppBuilder = window.location.pathname.startsWith("/appbuilder");

  const isCustomFormFieldShowcase =
    window.location.pathname.startsWith("/customcomponent");

  if (isCustomFormFieldShowcase) {
    return <CustomFormFieldShowcase />;
  }

  if (isPortal) {
    return <PortalApp />;
  }

  if (isAppBuilder) {
    return <AppBuilder />;
  }

  return <App />;
};

root.render(<RootApp />);

registerServiceWorker();
